module.exports = __webpack_public_path__ + "static/media/rating-star-empty.97a52722.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rating-star-empty.svg
// module id = 432
// module chunks = 0